import { all, fork } from 'redux-saga/effects';
import { domainSaga } from './domain/domain.saga';
import { userSaga } from './user/user.saga';
import { contactsSaga } from './contacts/contacts.saga';
import { senderAccountsSaga } from './senderAccounts';
import { attributesSaga } from './attributes/attributes.saga';
import { segmentsSaga } from './segments/segments.saga';
import { segmentChangeHistorySaga } from './segmentChangeHistory';
import { apiKeysSaga } from './apiKeys/apiKeys.saga';
import { campaignSaga } from './campaigns/campaigns.saga';
import { workflowsSaga } from './workflows/workflows.saga';
import { emailTemplatesSaga } from './emailTemplates/emailTemplates.saga';
import { emailSentHistorySaga } from './emailSentHistory';
import { workspaceSaga } from './workspace';
import { unsubscribeGroupsSaga } from './unsubscribeGroups';
import { unsubscribePreferenceSaga } from './unsubscribePreference/unsubscribePreference.saga';
import { activitySaga } from './activity';
import { trackContactCreationSaga } from './trackContactCreation/trackContactCreation.saga';
import { accountsSaga } from './accounts';
import { eventsSaga } from './events/events.saga';
import { eventAttributesSaga } from './eventAttributes/eventAttributes.saga';
import { paymentsSaga } from './payments';

export default function* rootSaga() {
  yield all([
    fork(domainSaga),
    fork(userSaga),
    fork(contactsSaga),
    fork(senderAccountsSaga),
    fork(attributesSaga),
    fork(segmentsSaga),
    fork(segmentChangeHistorySaga),
    fork(apiKeysSaga),
    fork(campaignSaga),
    fork(workflowsSaga),
    fork(emailTemplatesSaga),
    fork(emailSentHistorySaga),
    fork(workspaceSaga),
    fork(unsubscribeGroupsSaga),
    fork(unsubscribePreferenceSaga),
    fork(activitySaga),
    fork(trackContactCreationSaga),
    fork(accountsSaga),
    fork(eventsSaga),
    fork(eventAttributesSaga),
    fork(paymentsSaga),
  ]);
}
